<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">出入库管理<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>

            <div class="content-input-item">
              <label>变动</label>
              <el-select v-model="preType" placeholder="Select" class="select-item" @change="preTypeChange">
                <el-option v-for="item in preTypeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>类型</label>
              <el-select v-model="type" placeholder="Select" class="select-item">
                <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <!--              <label>供应商</label>-->
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" width="7em"/>
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap; flex-shrink: 0">有限制</span></el-checkbox>
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
<!--            <el-button type="primary" @click="editCommodityDialog(-1)" size="default">添加</el-button>-->
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="shopName" label="所属门店" v-if="checkColList.indexOf('所属门店') > -1"/>
            <el-table-column property="supplierName" label="变动" v-if="checkColList.indexOf('变动') > -1">
              <template #default="scope">
                <p>{{scope.row.type > 0?'入库':'出库'}}</p>
              </template>
            </el-table-column>
            <el-table-column property="supplierName" label="类型" v-if="checkColList.indexOf('类型') > -1">
              <template #default="scope">
                <p>{{scope.row.type == -5?'核销券码':scope.row.type == -4?'报损出库':scope.row.type == -3?'赠送出库':scope.row.type == -2?'售卖出库':scope.row.type == -1?'系统出库':scope.row.type == 1?'系统入库':scope.row.type == 2?'采购入库':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column property="brandName" label="数量（赠送）" v-if="checkColList.indexOf('数量（赠送）') > -1">
              <template #default="scope">
                <p>{{scope.row.stockStatNum.num + scope.row.stockStatNum.giveNum}}<span v-if="scope.row.stockStatNum.giveNum">（{{scope.row.stockStatNum.giveNum}}）</span></p>
              </template>
            </el-table-column>
            <el-table-column property="name" label="总计" v-if="checkColList.indexOf('总计') > -1">
              <template #default="scope">
                <p>{{scope.row.stockStatNum.money}}</p>
              </template>
            </el-table-column>
            <el-table-column property="updateTime" label="出入库时间" v-if="checkColList.indexOf('出入库时间') > -1" width="200"/>
            <el-table-column property="numberNo" label="关联批次号" v-if="checkColList.indexOf('关联批次号') > -1"/>
            <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
              <template #default="scope">
                <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 1?'待入库':scope.row.state == 2?'已驳回':scope.row.state == 3?'部分入库':scope.row.state == 4?'已入库':scope.row.state == 5?'已出库':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column property="adminName" label="添加人" v-if="checkColList.indexOf('添加人') > -1"/>
            <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1"  width="200" class-name="cursor"/>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
                <el-space wrap>
                  <el-button v-if="scope.row.state == 1 || scope.row.state == 2 || scope.row.state == 3" @click="editStockListDialog(scope.$index,scope.row)" size="small" type="primary">验货入库</el-button>
                  <el-button v-else @click="editStockListDialog(scope.$index,scope.row)" size="small" type="success">详情</el-button>
                </el-space>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import { getStockPageList, updateCommodityState} from "@/api/url";
// import CommodityDialog from "./components/CommodityDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import DatePickerRange from "@/components/DatePickerRange";
import StockRemarkDialog from "@/views/stock/components/StockRemarkDialog";
import StockListDialog from "@/views/stock/components/StockListDialog";
import unLock from "@/layout/components/unLock";

export default {
  name: "StockIndex",
  components: { BtnGroup, SearchComponents,DatePickerRange, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      limitState: false,

      shopIdArray: [],
      shopIdArr:[],
      shopId: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待入库', value: 1},
        {label: '已驳回', value: 2},
        {label: '部分入库', value: 3},
        {label: '已入库', value: 4},
        {label: '已出库', value: 5},
      ],
      state: -1,

      preTypeArray: [
        {label: '不限', value: -1},
        {label: '入库', value: 1},
        {label: '出库', value: 2}
      ],
      preType: -1,

      typeArray: [
        {label: '不限', value: 0}
      ],

      type2Array: [
        {label: '报损出库', value: -4},
        {label: '赠送出库', value: -3},
        {label: '售卖出库', value: -2},
        {label: '系统出库', value: -1},
        {label: '核销券码', value: -5},
      ],
      type1Array: [
        {label: '系统入库', value: 1},
        {label: '采购入库', value: 2}
      ],

      type: 0,

      //刷新组
      colList: ['所属门店', '变动', '类型', '数量（赠送）', '总计', '出入库时间','关联批次号', '状态', '添加人', '备注', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '批次号', value : 1},
        {label : '添加人', value : 2},
      ],
      searchType: 1,
      searchValue: '',

    }
  },
  methods: {
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.state = -1;
      this.limitState = false;
      this.preType = -1;
      this.type = 0;
      this.searchValue = '';
      this.searchType = 1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    preTypeChange() {
      this.type = 0
      this.typeArray = [
        {label: '不限', value: 0}
      ]
      if(this.preType == -1) {
        this.typeArray = [...this.typeArray, ...this.type1Array, ...this.type2Array]
      }
      if(this.preType == 1) {
        this.typeArray = [...this.typeArray, ...this.type1Array]
      }
      if(this.preType == 2) {
        this.typeArray = [...this.typeArray, ...this.type2Array]
      }
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['preType'] = this.preType;
      param['type'] = this.type;
      param['limitState'] = this.limitState?1:0;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['shopId'] = this.shopId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getStockPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editStockListDialog(idx, row) {
      let _title = row.type>0?'入库详情':'出库详情';
      let stockForm = Object.assign({}, row);
      Dialog.open({
        title: _title,
        component: StockListDialog,
        data: {
          stockForm: stockForm,
          ids: idx,
          width: '1400px',
        },
        close: (result) => {
          this.getPage()
        }
      })
    },


    updateState(row, state) {
      row.updateLoading = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateCommodityState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        row.updateLoading = false;
      }).catch(()=> {
        row.updateLoading = false;
      })
    },

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.commodityImgList,
          id: row.id,
          width: 908,
          from: 2
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    toggleSelection(row, column, cell, event) {

      //更新用户日志
      if (column.label == '备注') {
        let remarkForm = Object.assign({}, row);
        Dialog.open({
          title: '备注',
          component: StockRemarkDialog,
          data: {
            remarkForm: remarkForm,
            width: '500px'
          },
          close: () => {
            this.getPage()
          }
        })
      }
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    this.shopId = this.shopIdArray[0].id
    this.getPage();
    this.preTypeChange()
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 80px;
  height: 80px;
}
</style>
